// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__biaaS","paramInput":"JobSimulator_paramInput__1RxVU","input":"JobSimulator_input__24PJA"};